import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ServiceTimes from '../components/ServiceTimes';
import OnlineSection from '../components/OnlineSection';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/toaster';

const Home = () => {
  const navigate = useNavigate();
  const goToVisit = () => navigate('/plan-a-visit');

  return (
    <div className="bg-[#0a1030]">
      <Navbar onBook={goToVisit} />
      <Hero />
      <ServiceTimes onPlanVisit={goToVisit} />
      <OnlineSection
        onClick={() =>
          window.open(
            'https://www.youtube.com/@ACT_238/streams',
            '_blank',
            'noopener,noreferrer'
          )
        }
      />
      <Footer />
      <Toaster />
    </div>
  );
};

export default Home;
